export const CREATE_ENTRY = "CREATE_ENTRY";
export const FETCH_ENTRY = "FETCH_ENTRY";
export const FETCH_ENTRIES = "FETCH_ENTRIES";
export const DELETE_ENTRY = "DELETE_ENTRY";
export const EDIT_ENTRY = "EDIT_ENTRY";
export const ADD_ENTRY = "ADD_ENTRY";
export const SET_ADRESS_LIST = "SET_ADRESS_LIST";
export const RESET_EDITED_KUNDE = "RESET_EDITED_KUNDE";
export const SET_KUNDEN_ID = "SET_KUNDEN_ID";
export const SET_KONTO_SELECTED = "SET_KONTO_SELECTED";
